import { IconPropsType } from '..';

export const FuturesIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5 15.5L12.2456 15.5007L13 17.4999L6.28014 17.5C5.37691 17.5 4.60045 17.1781 3.95076 16.5345C3.31692 15.8747 3 15.0862 3 14.1689V6.83101C3 5.91377 3.31692 5.13331 3.95076 4.48963C4.60045 3.82986 5.37691 3.49998 6.28014 3.49998H13V5.5H5C5 8.83333 5 12.1667 5 15.5Z" />
    <path d="M12 15.5V17.5H13.7199C14.6231 17.5 15.3995 17.1782 16.0492 16.5345C16.6831 15.8747 17 15.0862 17 14.169L17 12.5H15V15.5C15 15.5 13.7224 15.5 12 15.5Z" />
    <path d="M15 5.5H12L12 3.5H13.7199C14.6231 3.5 15.3995 3.82184 16.0492 4.46552C16.6831 5.12529 17 5.91379 17 6.83104L17 8.5H15V5.5Z" />
    <path d="M7 3.5V0.5L9 0.5V3.5H7Z" />
    <path d="M7 20.5V17.5H9V20.5H7Z" />
    <path d="M11 3.5V0.5L13 0.5V3.49998L11 3.5Z" />
    <path d="M11 20.5V17.5L13 17.4999V20.5H11Z" />
  </svg>
);
